module.exports = __webpack_public_path__ + "static/media/4.1e1a399e.jpg";